// extracted by mini-css-extract-plugin
module.exports = {"vendorListGroupedWrapper":"_3PEoKcWzsn_r5t2lXP_O9X","vendorListGroupedTitle":"H_zit_RXqgZSTZtGfZCbP"};